import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FriendlyCaptchaComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { emailRegex } from '../../../../assets/regex';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { AnimatedCheckComponent } from '../../snippets/animated-check/animated-check.component';

@Component({
  selector: 'app-unsubscribe-talentpool',
  templateUrl: './unsubscribe-talentpool.component.html',
  styleUrls: ['./unsubscribe-talentpool.component.scss'],
  imports: [ReactiveFormsModule, TranslocoPipe, AnimatedCheckComponent, FriendlyCaptchaComponent],
})
export class UnsubscribeTalentpoolComponent implements OnInit {
  @ViewChild(FriendlyCaptchaComponent) captcha: FriendlyCaptchaComponent;

  success = signal(false);

  form = new FormGroup({
    email: new FormControl(null, [
      Validators.required,
      Validators.pattern(emailRegex),
    ]),
    captchaCode: new FormControl(null, [Validators.required]),
  });
  formSubmitAttempt = signal(false);

  private jobboardAdapter = inject(JobboardAdapter);

  ngOnInit(): void {}

  submitUnsubscribeForm() {
    this.formSubmitAttempt.set(true);

    if (this.form.valid) {
      this.jobboardAdapter
        .unsubscribeTalentpool({
          email: this.form.value.email,
          captchaCode: this.form.value.captchaCode,
        })
        .subscribe(() => {
          this.success.set(true);
        });
    }
  }

  get captchaCode() {
    return this.form.get('captchaCode');
  }
}
